import { connect } from 'react-redux'
import { selectOverlay } from '../../selectors/overlay'
import { Overlay as Component } from './Overlay'

export const Overlay = connect(selectOverlay)(Component)
